import React from 'react';
import { FileText, Trash2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';

const USE_BTN_STYLE = {
  background: 'transparent',
  border: '1px solid rgba(255,215,0,0.4)',
  color: '#FFD700',
  cursor: 'pointer',
  padding: '4px 10px',
  borderRadius: '8px',
  fontSize: '0.8rem',
  fontWeight: 600,
};

const TRASH_BTN_STYLE = {
  background: 'transparent',
  border: 'none',
  color: '#ef4444',
  cursor: 'pointer',
  padding: '4px',
  borderRadius: '6px',
  display: 'flex',
  alignItems: 'center',
};

const SavedListsCard = ({ savedLists, onUseList, onDeleteList }) => (
  <Card className="history-card" data-testid="saved-lists-card">
    <CardHeader>
      <CardTitle className="email-card-title">
        <FileText size={20} />
        Saved Email Lists ({savedLists.length})
      </CardTitle>
    </CardHeader>
    <CardContent>
      {savedLists.length === 0 ? (
        <p className="no-history">
          No saved lists yet. Use &quot;Import CSV / List&quot; above to save a recipient list (e.g. from Leaguelineup)
          for one-click sending.
        </p>
      ) : (
        <div className="history-list" data-testid="saved-lists-list">
          {savedLists.map((list) => (
            <div
              key={list.id}
              className="history-item"
              style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
              data-testid={`saved-list-${list.id}`}
            >
              <div style={{ flex: 1 }}>
                <div className="history-subject">{list.name}</div>
                <div className="history-meta" style={{ gap: '0.75rem' }}>
                  <span>{list.count} recipient{list.count === 1 ? '' : 's'}</span>
                  {list.created_at && (
                    <span style={{ opacity: 0.7 }}>
                      {new Date(list.created_at).toLocaleDateString()}
                    </span>
                  )}
                </div>
              </div>
              <button
                type="button"
                onClick={() => onUseList(list)}
                title="Use this list as recipients"
                data-testid={`use-saved-list-${list.id}`}
                style={USE_BTN_STYLE}
              >
                Use
              </button>
              <button
                type="button"
                onClick={(e) => onDeleteList(list, e)}
                title="Delete saved list"
                data-testid={`delete-saved-list-${list.id}`}
                style={TRASH_BTN_STYLE}
              >
                <Trash2 size={14} />
              </button>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);

export default SavedListsCard;
